export default __webpack_public_path__ + "resources/icons/n142-f7b7.png";